import './bootstrap.less';

// import 'bootstrap/js/affix';
import 'bootstrap/js/alert';
import 'bootstrap/js/button';
// import 'bootstrap/js/carousel';
import 'bootstrap/js/collapse';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/modal';
// import 'bootstrap/js/scrollspy';
import 'bootstrap/js/tab';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/popover';
// import 'bootstrap/js/transition';

/**
 * Fixes transition issue in >IE10
 * @see https://github.com/twbs/bootstrap/pull/4109
 * @see https://github.com/twbs/bootstrap/commit/6ba4008df247f9b3dbeb5c3b5522802f866c202c
 */
/*
$.support.transition = (function () {

    const transitionEnd = (function () {

        const el = document.createElement('bootstrap'),
            transEndEventNames = {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd',
                transition: 'transitionend'
            };

        for (const name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }

    }());

    return transitionEnd && {
        end: transitionEnd
    };

})();
*/


// WEBPACK FOOTER //
// ./init/bootstrap.js